import getLangLocale from 'I18n/utils/getLangLocale';
import { getApiClient } from './apiClient';
import { getQuickFetch } from './ecosystemClient';
let qualityApiBase = 'marketplace/quality/customer/v1';
const qualityAdminApiBase = 'marketplace/quality/v1';
export const setQualityApiBase = base => {
  qualityApiBase = base;
};
export function getCallouts() {
  return getQuickFetch('callouts').catch(() => {
    return getApiClient().get(`${qualityApiBase}/self-serve/callouts/published?offeringType=THEME`, {
      query: {
        locale: getLangLocale()
      }
    });
  });
}
export function getCollections(appContext) {
  return getQuickFetch('collections').catch(() => {
    const isAdminPreview = appContext === 'ADMIN_PREVIEW';
    const apiBase = isAdminPreview ? qualityAdminApiBase : qualityApiBase;
    return getApiClient().get(`${apiBase}/self-serve/themes/collections${isAdminPreview ? '' : '/published'}`, {
      query: {
        locale: getLangLocale()
      }
    });
  });
}
export function getThemeCollectionItems(collectionId) {
  return getApiClient().get(`${qualityApiBase}/self-serve/themes/collections/${collectionId}/items`);
}
export function getThemeCollectionPreviewItems(collectionId) {
  return getApiClient().get(`${qualityAdminApiBase}/self-serve/themes/collections/${collectionId}/items`);
}
export const reportReview = ({
  reviewId,
  reportReason,
  comment
}) => getApiClient().post(`${qualityApiBase}/reviews/${reviewId}/report`, {
  data: {
    reportReason,
    comment
  }
});
export const reportReply = ({
  reviewId,
  replyId,
  reportReason,
  comment
}) => getApiClient().post(`${qualityApiBase}/reviews/${reviewId}/replies/${replyId}/report`, {
  data: {
    reportReason,
    comment
  }
});